import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=1b6f847d&scoped=true"
import script from "./DataCell.vue?vue&type=script&lang=js"
export * from "./DataCell.vue?vue&type=script&lang=js"
import style0 from "./DataCell.vue?vue&type=style&index=0&id=1b6f847d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f847d",
  null
  
)

export default component.exports